<div class="dialog-wrap">
  <div class="messages">
    <ng-container *ngFor="let m of messages">
      <div class="message-row" [ngClass]="m.from" #bubble>
        <div class="avatar" aria-hidden="true">
          @if(m.avatar) {
          <img [src]="'../../../../assets/images/comic-chat/avatar/' + m.avatar + '.jpg'" alt="" />
          } @else { @if(m.from === 'left') {
          <img src="../../../../assets/images/comic-chat/1.jpeg" alt="" />
          } @else {
          <img src="../../../../assets/images/comic-chat/2.jpeg" alt="" />
          } }
        </div>

        <div class="bubble">
          <div class="bubble-text">{{ m.message }}</div>
          <h5 class="d-none" *ngIf="m.from == 'left'; else rightMessage">{{ m.message }}</h5>
          <ng-template #rightMessage>
            <h6 class="d-none">{{ m.message }}</h6>
          </ng-template>
          <ng-container *ngIf="isAdmin">
            <button class="delete-btn" (click)="deleteMessage(m.id)" title="Delete message">
              <i class="fa-solid fa-trash"></i>
            </button>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <div class="message-btn" *ngIf="isAdmin">
      <button class="btn btn-sm btn-outline-secondary mr-2 mb-2" (click)="openAddMessageModal(addMessageModal)"><i class="fa-solid fa-plus"></i> Add New Chat Comic</button>
      <ng-content></ng-content>
    </div>
  </div>
</div>

<!-- Add New Chat Comic Modal -->
<!-- <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Add New Chat Comic</h3>
      <button class="close-btn" (click)="closeModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="addNewMessage()" #messageForm="ngForm">
        <div class="form-group">
          <label for="messageText">Message Text:</label>
          <textarea id="messageText" name="messageText" [(ngModel)]="newMessage.text" required placeholder="Enter your message..." rows="4" class="form-control"> </textarea>
        </div>
        <div class="form-group">
          <label for="messageFrom">From:</label>
          <select id="messageFrom" name="messageFrom" [(ngModel)]="newMessage.from" required class="form-control p-0">
            <option value="left">Left (Character 1)</option>
            <option value="right">Right (Character 2)</option>
          </select>
        </div>
        <div class="form-group">
          <label>Avatar:</label>
          <div class="avatar-selector">
            <div *ngFor="let avatar of availableAvatars; let i = index" class="avatar-option" [class.selected]="newMessage.avatar === avatar" (click)="selectAvatar(avatar)">
              <img [src]="'/assets/images/comic-chat/avatar/' + avatar + '.jpg'" [alt]="'Avatar ' + avatar" class="avatar-image" />
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="!messageForm.valid">Add Message</button>
        </div>
      </form>
    </div>
  </div>
</div> -->

<ng-template #addMessageModal>
  <div class="my-modal__close" (click)="closeModal()">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <h2 class="title">Add New Chat Comic</h2>

    <form class="add-message" (ngSubmit)="addNewMessage()" #messageForm="ngForm">
      <div class="form-group">
        <label for="messageText">Message Text:</label>
        <textarea id="messageText" name="messageText" [(ngModel)]="newMessage.text" required placeholder="Enter your message..." rows="4" class="form-control"> </textarea>
      </div>
      <div class="form-group">
        <label for="messageFrom">From:</label>
        <select id="messageFrom" name="messageFrom" [(ngModel)]="newMessage.from" required class="form-control p-0">
          <option value="left">Left (Character 1)</option>
          <option value="right">Right (Character 2)</option>
        </select>
      </div>
      <div class="form-group">
        <label>Avatar:</label>
        <div class="avatar-selector">
          <div *ngFor="let avatar of availableAvatars; let i = index" class="avatar-option" [class.selected]="newMessage.avatar === avatar" (click)="selectAvatar(avatar)">
            <img [src]="'/assets/images/comic-chat/avatar/' + avatar + '.jpg'" [alt]="'Avatar ' + avatar" class="avatar-image" />
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">Cancel</button>
        <button type="submit" class="my-button-3" [disabled]="!messageForm.valid">Add Message</button>
      </div>
    </form>
  </div>
</ng-template>
